<template>
  <RolePicker />
  <ItemsPicker />
  <ExtraOptionPicker :options="['server']" />
  <PlatformPicker />
  <OptionPicker />
</template>

<script setup>
import OptionPicker from "./pickers/OptionPicker.vue";
import ExtraOptionPicker from "./pickers/ExtraOptionPicker.vue";
import PlatformPicker from "../commonpickers/PlatformPicker.vue";
import RolePicker from "./pickers/RolePicker.vue";
import ItemsPicker from "./pickers/ItemsPicker.vue";

import { onMounted } from "vue";
const checkoutStore = useCheckoutStore();
const { setDetails, setServer, setPlatform, setGameAndPack, setRole } =
  checkoutStore;

const { getGame, getGamePack } = useGameStore();

const handleDetails = () => {
  checkoutStore.clearCheckout();
  setDetails({
    gadgetsAndWeapons: [1],
  });
  setServer("82");
  setRole("15");
  setPlatform({
    platform: 1,
  });

  setGameAndPack({
    game: getGame.id,
    pack: getGamePack.id,
    fullGame: getGame,
    fullPack: getGamePack,
  });
};

handleDetails();
onMounted(() => {
  // checkoutStore.clearCheckout("test");
  checkoutStore.setCalculating();
});
</script>
